import React from 'react'
import Footer from '../components/Footer/Footer'
import Sidebar from '../components/SideBar/Sidebar'

import Sign from '../components/SignIn/Sign'



const SignIn = () => {
    return (
        <>
        <Sidebar/>
        <Sign/>
        <Footer/>
        </>
    )
}

export default SignIn
